var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('filter-builder',{on:{"data-changed":_vm.applyFilteredData}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('filter-result-preview-table',{attrs:{"persons":_vm.persons,"total-match-count":_vm.matchCount,"show-column-selection-input":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }